 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"cdb326bf951f94876a2e7e1a74c8bd6395fcc6f7","1":"aecd36275ff28a43bd02e40384c8bd5c3636716e","2":"76d589d8e3323d19e54b466c5d04820a749ede30","3":"a9a7754c","4":"styles","5":"6a06b467e1eb40b5733f38aa70ffc0794f49bb4d","6":"cb1608f2","7":"b2996cc7aacc40e7beeac70d084dc31a3aa1ac5c","8":"52d37a21391a3f7dc6a80eb8d6d7da6e8dc91929","9":"ef25e07643fcdc1fcf3555a5f56fd53d7f3073ef","10":"62aca486f23f754cd5b96cbb660ae90f7f3e122d","11":"f95a1e7ccc53d664230854905897779987484f03","12":"2c796e83","13":"d7d31e7ac39eea6685a36825ffc03a0b6aa60454","14":"e7effbc788ea880b35879eb1480c3cf41f11a517","17":"component---node-modules-gatsby-plugin-offline-app-shell-js","18":"component---src-pages-404-js","19":"component---src-pages-app-js","20":"component---src-pages-bar-index-js","21":"component---src-pages-bar-outdoor-js","22":"component---src-pages-contact-js","23":"component---src-pages-event-index-js","24":"component---src-pages-hotel-index-js","25":"component---src-pages-index-js","26":"component---src-pages-lokal-conference-js","27":"component---src-pages-lokal-dinner-js","28":"component---src-pages-lokal-index-js","29":"component---src-pages-lokal-party-js","30":"component---src-pages-lostandfound-index-js","31":"component---src-pages-news-js","32":"component---src-pages-newsall-js","33":"component---src-pages-nightlife-index-js","34":"component---src-pages-nightlife-newyear-js","35":"component---src-pages-nightlife-reservedtable-js","36":"component---src-pages-policies-index-js","37":"component---src-pages-policies-policy-js","38":"component---src-pages-press-iframe-js","39":"component---src-pages-press-index-js","40":"component---src-pages-restaurant-brunch-js","41":"component---src-pages-restaurant-chambre-js","42":"component---src-pages-restaurant-christmastable-js","43":"component---src-pages-restaurant-cocktail-js","44":"component---src-pages-restaurant-dinner-js","45":"component---src-pages-restaurant-index-js","46":"component---src-pages-restaurant-lunch-js","47":"component---src-pages-restaurant-uteservering-js","48":"component---src-pages-stureplansgruppen-js","49":"component---src-templates-bar-template-js","50":"component---src-templates-event-template-js","51":"component---src-templates-hotel-template-js","52":"component---src-templates-lokal-template-js","53":"component---src-templates-newstemplate-js","54":"component---src-templates-nightlife-template-js","55":"component---src-templates-restaurant-template-js","56":"component---src-templates-small-talks-template-js"}[chunkId]||chunkId) + "-" + {"0":"16b23bdce483c0437edb","1":"159e80427d32eed38a3b","2":"b8a297a692a7848c7838","3":"4ab21572140feb1f8af7","4":"08bc34de4ea872a98d93","5":"e0a76af62513bc6df6e1","6":"61f99c26ebf13d9798e1","7":"b9890099ccb3739f360d","8":"542a96ee68b329269cde","9":"94be5ed05799aa4e5447","10":"d77f1927a8b2dc00db74","11":"23982cfd63004784a3d4","12":"25799b48de8782266fc6","13":"2c466c10a9cbb64f875c","14":"bb30104d4771efe320b1","17":"f8ccea166015ac3806cf","18":"c3ee05c42a31792e9dc2","19":"01a27034115a4246b68f","20":"409fc32c28d9ba5d5fa2","21":"2aa8156fb0e96c40f4f7","22":"ab378fe3ccf1093e5fe5","23":"2daffae1ca157b1a00d8","24":"7c36c076ec38e4dcae1b","25":"6927fcade61218d67ce2","26":"92fd70c9f29dbe84732f","27":"d314ff892461ee58f838","28":"7994d04f382b8350cc7c","29":"36dd441838b3f6c9befb","30":"fb2bea42c43876fa9e4e","31":"d8b33b30e1d46eee789b","32":"12170f376f96c22290a9","33":"f5a496e4b7328ac8d7a1","34":"ae6a2d5a02cce46f47b2","35":"00756b3d9a14b5b37b16","36":"96c8d91476bb188c66d7","37":"1d724df0ae8bbb61867a","38":"de776329617d108dd0c1","39":"c01546d3dd6221183f38","40":"ef008a67eae322ca2a3b","41":"d09e4cb2087f81233f04","42":"3f291e4c5815ad5b79ab","43":"dddaf80e227cb061e7ad","44":"990c590348e6afd411b5","45":"8e1f36016f6d1b7a736b","46":"2abc344f4f9dcebe3e92","47":"57767980596614a11341","48":"abbb859c1666614bf5e5","49":"a53c0361fd49382bfcd7","50":"f04410360ea27305bde1","51":"154f2256962bfe2e6736","52":"8cdf83bb3d6114e7414b","53":"5dc1339a4dbdb4b8d92f","54":"e3fa1f6b45dbda841677","55":"ff2bd0a21dec8a5c7ee0","56":"d5485d6b31e2a056eb1d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"cdb326bf951f94876a2e7e1a74c8bd6395fcc6f7","1":"aecd36275ff28a43bd02e40384c8bd5c3636716e","2":"76d589d8e3323d19e54b466c5d04820a749ede30","3":"a9a7754c","4":"styles","5":"6a06b467e1eb40b5733f38aa70ffc0794f49bb4d","6":"cb1608f2","7":"b2996cc7aacc40e7beeac70d084dc31a3aa1ac5c","8":"52d37a21391a3f7dc6a80eb8d6d7da6e8dc91929","9":"ef25e07643fcdc1fcf3555a5f56fd53d7f3073ef","10":"62aca486f23f754cd5b96cbb660ae90f7f3e122d","11":"f95a1e7ccc53d664230854905897779987484f03","12":"2c796e83","13":"d7d31e7ac39eea6685a36825ffc03a0b6aa60454","14":"e7effbc788ea880b35879eb1480c3cf41f11a517","17":"component---node-modules-gatsby-plugin-offline-app-shell-js","18":"component---src-pages-404-js","19":"component---src-pages-app-js","20":"component---src-pages-bar-index-js","21":"component---src-pages-bar-outdoor-js","22":"component---src-pages-contact-js","23":"component---src-pages-event-index-js","24":"component---src-pages-hotel-index-js","25":"component---src-pages-index-js","26":"component---src-pages-lokal-conference-js","27":"component---src-pages-lokal-dinner-js","28":"component---src-pages-lokal-index-js","29":"component---src-pages-lokal-party-js","30":"component---src-pages-lostandfound-index-js","31":"component---src-pages-news-js","32":"component---src-pages-newsall-js","33":"component---src-pages-nightlife-index-js","34":"component---src-pages-nightlife-newyear-js","35":"component---src-pages-nightlife-reservedtable-js","36":"component---src-pages-policies-index-js","37":"component---src-pages-policies-policy-js","38":"component---src-pages-press-iframe-js","39":"component---src-pages-press-index-js","40":"component---src-pages-restaurant-brunch-js","41":"component---src-pages-restaurant-chambre-js","42":"component---src-pages-restaurant-christmastable-js","43":"component---src-pages-restaurant-cocktail-js","44":"component---src-pages-restaurant-dinner-js","45":"component---src-pages-restaurant-index-js","46":"component---src-pages-restaurant-lunch-js","47":"component---src-pages-restaurant-uteservering-js","48":"component---src-pages-stureplansgruppen-js","49":"component---src-templates-bar-template-js","50":"component---src-templates-event-template-js","51":"component---src-templates-hotel-template-js","52":"component---src-templates-lokal-template-js","53":"component---src-templates-newstemplate-js","54":"component---src-templates-nightlife-template-js","55":"component---src-templates-restaurant-template-js","56":"component---src-templates-small-talks-template-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"0d83977d7d64dae1a19b","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
